import React from 'react';
import PropTypes from 'prop-types';

const Spinner = ({ size }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <style>
        {`
          @keyframes spin {
            0% { opacity: 0.2; }
            20% { opacity: 1; }
            100% { opacity: 0.2; }
          }
          .spinner-dot {
            animation: spin 1.5s linear infinite;
          }
        `}
      </style>
      <g fill="#cdced0">
        {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => {
          const positions = [
            [50, 20],
            [71.65, 28.35],
            [80, 50],
            [71.65, 71.65],
            [50, 80],
            [28.35, 71.65],
            [20, 50],
            [28.35, 28.35]
          ];
          return (
            <circle
              key={i}
              className="spinner-dot"
              cx={positions[i][0]}
              cy={positions[i][1]}
              r="8"
              style={{ animationDelay: `-${i * 0.125}s` }}
            />
          );
        })}
      </g>
    </svg>
  );
};

Spinner.propTypes = {
  size: PropTypes.number
};

export default Spinner;
